import styled from 'styled-components';

import Button from '@legacy/moon/particles/Button';
import { FlexContainer } from '@legacy/moon/Layout';
import { TinyText } from '@legacy/moon/particles/Typography';

import colors from '@legacy/moon/particles/colors';

const ErrorContainer = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  background-color: ${colors.moonlight10};
  height: 100%;
  width: 100%;
  border-radius: 1rem;
  padding: 16px;
`;

const ErrorText = styled(TinyText)`
  color: ${colors.moonlight60};
  margin-bottom: 1rem;
`;

const ErrorButton = styled(Button)`
  min-height: unset;
  min-width: unset;
  height: 32px;
  padding: 4px 24px;
`;

export { ErrorContainer, ErrorText, ErrorButton };
